angular.module('capability-ng-global').component('loadingIndicator', {
  templateUrl: 'lib/global/components/loading_indicator/loading_indicator.html',
  bindings: {
    size: '<'
  }
});



// WEBPACK FOOTER //
// ./app/lib/global/components/loading_indicator/loading_indicator.ts